import { ReactNode, useEffect } from 'react'
import { isApolloError } from '@apollo/client'

import { TOAST_TYPE_DANGER, ToastProps, useToast } from '@divvy-web/skylab.toast'

import { logError } from '@sputnik/utils/loggerUtils'

interface ToastOptions {
  message: NonNullable<ReactNode>
  options?: ToastProps
}

interface LoggingOptions {
  message: string
  eventName: string
  action?: string
  attributes?: object
}

export interface UseApolloErrorHandlingParams {
  error?: Error
  toast?: ToastOptions
  logging?: LoggingOptions
  customAction?: () => void
}

export const useApolloQueryErrorHandling = ({ error, toast, logging, customAction }: UseApolloErrorHandlingParams) => {
  const showToast = useToast()

  useEffect(() => {
    if (error && isApolloError(error)) {
      if (logging) {
        const { message, eventName, action, attributes } = logging
        logError(error, {
          attributes: {
            ...attributes,
            action: action || eventName,
            message: error?.message,
            result: message,
          },
          eventName,
        })
      }

      if (toast) {
        const { message, options } = toast

        showToast(TOAST_TYPE_DANGER, message, { className: 'dd-privacy-allow', ...options })
      }

      customAction?.()
    }
  }, [error, showToast, logging, customAction, toast])
}
